import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
} from '@mui/material';
import { Logout, DevicesOther } from '@mui/icons-material';

interface LogoutOptionsDialogProps {
  open: boolean;
  onClose: () => void;
  onLogout: () => void;
  onLogoutAll: () => void;
}

export const LogoutOptionsDialog: React.FC<LogoutOptionsDialogProps> = ({
  open,
  onClose,
  onLogout,
  onLogoutAll,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      data-testid="logout-options-dialog"
    >
      <DialogTitle>Sign Out</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Choose how you want to sign out:
        </Typography>
        <Stack spacing={2}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<Logout />}
            onClick={onLogout}
            data-testid="logout-this-device-button"
            sx={{
              justifyContent: 'flex-start',
              py: 1.5,
            }}
          >
            Sign out of this browser
          </Button>
          <Button
            variant="outlined"
            color="error"
            fullWidth
            startIcon={<DevicesOther />}
            onClick={onLogoutAll}
            data-testid="logout-all-devices-button"
            sx={{
              justifyContent: 'flex-start',
              py: 1.5,
            }}
          >
            Sign out of all devices
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-testid="logout-cancel-button">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
